const getShoppingCartLoading = (state) => {
	return state.shoppingCartLoading;
};

export default {
	getShoppingCartLoading
};
